var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30 18 0 35V1l30 17Z",
  fill: "var(--thc-icon-fill)"
})));
export { SvgPlayIcon as ReactComponent };
export default new URL("/home/runner/_work/motorway-dealer-webapp/motorway-dealer-webapp/components/StaticPages/ProductPageComponents/VideoPoster/play-icon.svg", import.meta.url).toString();